<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{ 'FE.HEADER.USER.PROFILE.CHANGEACCOUNTMODAL.TITLE' | localize }}</h3>
		</div>
	</div>
	<form class="kt-form">
		<div class="kt-portlet__body">
			<div class="kt-portlet__body-progress">
				<mat-spinner [diameter]="20"></mat-spinner>
			</div>
			<div class="row">
				<div class="col-md-1">
					<div class="kt-notification__item-icon">
						<img width="60" alt="Pic" src="../../../../../../assets/media/client-logos/{{selectUserCustomer.customerGuid}}.png" />
					</div>
				</div>
				<div class="col-md-5 kt-margin-t-10">
					<div class="kt-notification__item-details">
						<div class="kt-notification__item-title kt-font-bold">
							<h5>{{selectUserCustomer.customerName}}</h5>
						</div>
						<div>
							<h6>{{selectUserCustomer.titleName}}</h6>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<label>{{ 'FE.HEADER.USER.PROFILE.CHANGEACCOUNTMODAL.LABELS.PASSWORD' | localize }} <i class="text-danger">*</i></label>
					<input type="password" placeholder="{{ 'FE.HEADER.USER.PROFILE.CHANGEACCOUNTMODAL.PLACEHOLDERS.PASSWORD' | localize }}" class="form-control" name="psw" #psw="ngModel"
						   [(ngModel)]="selectPassword" required minlength="4" />
					<mat-error *ngIf="psw.invalid && (psw.dirty || psw.touched)">
						<div *ngIf="psw.errors.required">
							{{'FE.REQUIREDFIELDS.COMMON.PASSWORD' | localize}}
						</div>
						<!--<div *ngIf="psw.errors.minlength">
							en az 4 karakter girmelisiniz
						</div>-->
					</mat-error>
				</div>
			</div>



		</div>
		<div class="modal-footer">
			<button type="button" mat-raised-button [mat-dialog-close]="'Yes'" cdkFocusInitial matTooltip="">
				 {{ 'FE.HEADER.USER.PROFILE.CHANGEACCOUNTMODAL.BUTTONS.CLOSE' | localize }}
			</button>&nbsp;
			<button type="button" mat-raised-button color="primary" class="btn btn-primary  kt-login__btn-primary"
					(click)="onClickChangeDefaultTitle()" matTooltip="">
				 {{ 'FE.HEADER.USER.PROFILE.CHANGEACCOUNTMODAL.BUTTONS.CHANGE' | localize }}
			</button>
		</div>
	</form>
</div>
